var _sodipodiNamedview, _defs, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPatent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    id: "svg7767",
    xmlSpace: "preserve",
    sodipodiDocname: "patent.svg",
    inkscapeVersion: "1.3.1 (9b9bdc1480, 2023-11-25, custom)",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview1",
    pagecolor: "#505050",
    bordercolor: "#eeeeee",
    borderopacity: 1,
    inkscapeShowpageshadow: 0,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDeskcolor: "#505050",
    inkscapeZoom: 9.9782109,
    inkscapeCx: 53.666935,
    inkscapeCy: 58.627744,
    "inkscapeWindow-width": 1920,
    "inkscapeWindow-height": 1006,
    "inkscapeWindow-x": 0,
    "inkscapeWindow-y": 1122,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "svg7767"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs7771"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 46.5,
    r: 44.5,
    stroke: "#42C0EF",
    strokeWidth: 3,
    id: "circle7765"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 34.468596,63.69103 C 29.218666,63.66179 26.375508,63.428898 24.520851,61.574189 22.399957,59.45324 22.399957,56.039747 22.399957,49.212756 v -9.654915 c 0,-6.827063 0,-10.240583 2.120894,-12.361476 2.120894,-2.120899 5.534416,-2.120899 12.361482,-2.120899 h 19.309832 c 6.826982,0 10.240473,0 12.36142,2.120899 2.120945,2.120893 2.120945,5.534413 2.120945,12.361476 v 9.654915 c 0,6.826991 0,10.240484 -2.120945,12.361433 -1.761538,1.761782 -4.415188,2.060114 -9.176027,2.110563 l -1.978529,0.0063",
    stroke: "#1C274D",
    strokeWidth: 3.62059,
    id: "path1",
    style: {
      stroke: "#42c0ef",
      strokeOpacity: 1,
      strokeWidth: 3,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 39.29606,34.730388 H 53.778436",
    stroke: "#1C274D",
    strokeWidth: 3.62059,
    strokeLinecap: "round",
    id: "path2",
    style: {
      stroke: "#42c0ef",
      strokeOpacity: 1,
      strokeWidth: 3,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 34.468596,43.178432 H 58.605882",
    stroke: "#1C274D",
    strokeWidth: 3.62059,
    strokeLinecap: "round",
    id: "path3",
    style: {
      stroke: "#42c0ef",
      strokeOpacity: 1,
      strokeWidth: 3,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 43.859212,53.908427 c 1.542851,-1.314759 3.81224,-1.314759 5.355343,0 0.661112,0.563603 1.483234,0.904179 2.349033,0.973213 2.021016,0.161238 3.625668,1.765884 3.786899,3.78666 0.06905,0.866045 0.409614,1.688158 0.972978,2.349282 1.315006,1.543095 1.315006,3.812488 0,5.355336 -0.563364,0.661127 -0.903938,1.483238 -0.972978,2.349284 -0.161231,2.020776 -1.765883,3.625423 -3.786899,3.786659 -0.865799,0.06929 -1.687921,0.409611 -2.349033,0.97322 -1.543103,1.314755 -3.812492,1.314755 -5.355343,0 -0.661364,-0.563609 -1.483246,-0.903942 -2.349316,-0.97322 -2.020817,-0.161236 -3.625511,-1.765883 -3.786772,-3.786659 -0.06905,-0.866046 -0.409625,-1.688157 -0.973094,-2.349284 -1.314901,-1.542848 -1.314901,-3.812241 0,-5.355336 0.563469,-0.661124 0.90399,-1.483237 0.973094,-2.349282 0.161261,-2.020776 1.765955,-3.625422 3.786772,-3.78666 0.86607,-0.06904 1.687952,-0.40961 2.349316,-0.973213 z",
    stroke: "#1C274D",
    strokeWidth: 3.62059,
    id: "path4",
    style: {
      stroke: "#42c0ef",
      strokeOpacity: 1,
      strokeWidth: 3,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 42.916644,64.177907 2.068754,1.931005 5.172282,-4.827522",
    stroke: "#1C274D",
    strokeWidth: 3.62056,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path5",
    style: {
      opacity: 1,
      stroke: "#42c0ef",
      strokeOpacity: 1,
      strokeWidth: 3,
      strokeDasharray: "none"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatent);
export default __webpack_public_path__ + "static/media/patent.809a2de283466386d27b9164e33d5160.svg";
export { ForwardRef as ReactComponent };